import IconButton from 'components/buttons/IconButton';
import { TableStyles } from './styles';

const MobileSubJsxToggleButton = ({ type, onClick }: { type: TableStyles; onClick: () => void }) => {
  return <IconButton iconType="expandless" type="tonal" size="sm" onClick={onClick} />;
};

export default MobileSubJsxToggleButton;
